/* @flow */
import * as React from 'react';

import GroupMemberFamily from 'groups/components/GroupMemberFamily.jsx';

import getField from '../ComposableTableField.jsx';
import type { Field } from '../ComposableTableField.jsx';

export function getFamilyCellGenerator(field: Field, groupMemberFamilyProps: Function) {
  return (data: Object) => {
    const cellProps = { familySummary: getField(data, field), ...groupMemberFamilyProps(data) };
    return <GroupMemberFamily {...cellProps} />;
  };
}
